import { FunctionComponent } from "react";

import {
  Dialog,
  SubmissionForm,
  TextInputField,
  Heading,
  Stack,
  Text
} from "@bps/fluent-ui";
import { IpRangeDto } from "@libs/api/gateways/plt-integrators/plt-integrators-gateway.dtos";
import { useCreateApplication } from "@libs/api/gateways/plt-integrators/plt-integrators-gateway.hooks";
import { Tenant } from "@libs/api/gateways/plt/plt-gateway.dtos";
import { Validator } from "@bps/validator";

export interface CreateApplicationDialogProps {
  tenant: Tenant;
  onDismiss: () => void;
}

export interface CreateApplicationFormValues {
  name: string;
  ipRanges?: IpRangeDto[];
}

const createApplicationValidator = new Validator<CreateApplicationFormValues>(
  validator => ({ name: validator.string().required() })
);

export const CreateApplicationDialog: FunctionComponent<CreateApplicationDialogProps> = ({
  tenant,
  onDismiss
}) => {
  const { mutateAsync: createApplication } = useCreateApplication();

  const onSubmit = async (formData: CreateApplicationFormValues) => {
    await createApplication({
      name: formData.name,
      tenantId: tenant.id,
      ipRanges: formData.ipRanges
    });
    onDismiss();
  };

  const defaultValues = {
    name: ""
  };

  return (
    <Dialog
      hidden={false}
      dialogContentProps={{
        title: "Create Application",
        showCloseButton: true,
        onDismiss
      }}
      minWidth={450}
    >
      <SubmissionForm<CreateApplicationFormValues>
        onSubmit={onSubmit}
        initialValues={defaultValues}
        validate={createApplicationValidator.validate}
        hideCancelButton
      >
        {() => (
          <>
            <TextInputField name="name" label="Name" required />
            <Heading labelPaddings>Ip Ranges (Optional)</Heading>

            <Stack tokens={{ childrenGap: 8 }} verticalAlign="space-between">
              <Stack
                horizontal
                tokens={{ childrenGap: 8 }}
                verticalAlign="center"
              >
                <TextInputField
                  name="ipRanges[0].ipRangeBegin"
                  placeholder="IP Range Begin"
                />
                <Text>to</Text>
                <TextInputField
                  name="ipRanges[0].ipRangeEnd"
                  placeholder="IP Range End"
                />
              </Stack>
              <Stack
                horizontal
                tokens={{ childrenGap: 8 }}
                verticalAlign="center"
              >
                <TextInputField
                  name="ipRanges[1].ipRangeBegin"
                  placeholder="IP Range Begin"
                />
                <Text>to</Text>
                <TextInputField
                  name="ipRanges[1].ipRangeEnd"
                  placeholder="IP Range End"
                />
              </Stack>
            </Stack>
          </>
        )}
      </SubmissionForm>
    </Dialog>
  );
};
